<template>
  <div>
    <SubHeader :text="$t('et.et')" :imgUrl="img" />
    <div>
      <div class="e">
        <div class="list reveal-bottom">
          <img
            style="margin-top: 19px"
            :src="require('@/assets/images/expert/CCIE.jpg')"
            width="100"
          />
          <img :src="require('@/assets/images/expert/CCNP.jpg')" width="110" />
          <img
            style="margin-top: 14px"
            :src="require('@/assets/images/expert/JNCIE.png')"
            width="90"
          />
          <img
            style="margin-top: 15px"
            :src="require('@/assets/images/expert/ITIL.jpg')"
            width="150"
          />
          <img
            style="margin-top: 16px"
            :src="require('@/assets/images/expert/MCSE.png')"
            width="140"
          />
        </div>
        <div class="list reveal-bottom">
          <img
            style="margin-top: 30px"
            :src="require('@/assets/images/expert/ISM.png')"
            width="150"
          />
          <img
            style="margin-top: 7px"
            :src="require('@/assets/images/expert/CISM.jpg')"
            width="150"
          />
          <img
            style="margin-top: 30px"
            :src="require('@/assets/images/expert/ASM.png')"
            width="190"
          />
          <img
            style="margin-top: 25px"
            src="data:image/png;base64,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"
            width="150"
          />
        </div>
      </div>
    </div>
    <div class="box">
      <Card
        v-for="(item, index) in teams"
        :key="index"
        :img="item.img"
        :name="item.name"
        :position="item.position"
        :description="item.description"
        :style="{ marginRight: (index + 1) % 4 === 0 ? '0' : '20px' }"
      />
    </div>
  </div>
</template>
<script>
import SubHeader from "@/components/SubHeader";
import Card from "./Card";
import initAnimation from "../animation";
export default {
  data() {
    return {
      img: require("@/assets/images/sub_page_banner_10.jpg"),
      teams: [
        {
          img: require("@/assets/images/expert/one.png"),
          name: "et.zhang",
          position: "et.zhangLabel",
          description: "et.zhangDesc",
        },
        {
          img: require("@/assets/images/expert/two.png"),
          name: "et.liu",
          position: "et.liuLabel",
          description: "et.liuDesc",
        },
        {
          img: require("@/assets/images/expert/three.png"),
          name: "et.wen",
          position: "et.wenLabel",
          description: "et.wenDesc",
        },
        {
          img: require("@/assets/images/expert/five.png"),
          name: "et.yan",
          position: "et.yanLabel",
          description: "et.yanDesc",
        },
        {
          img: require("@/assets/images/expert/nine.png"),
          name: "et.chen",
          position: "et.chenLabel",
          description: "et.chenDesc",
        },
        {
          img: require("@/assets/images/expert/six.png"),
          name: "et.maggie",
          position: "et.maggieLabel",
          description: "et.maggieDesc",
        },
        {
          img: require("@/assets/images/expert/seven.png"),
          name: "et.long",
          position: "et.longLabel",
          description: "et.longDesc",
        },
        {
          img: require("@/assets/images/expert/fourteen.png"),
          name: "et.quan",
          position: "et.quanLabel",
          description: "et.quanDesc",
        },
        {
          img: require("@/assets/images/expert/twelve.png"),
          name: "et.wu",
          position: "et.wuLabel",
          description: "et.wuDesc",
        },
        {
          img: require("@/assets/images/expert/ten.png"),
          name: "et.guo",
          position: "et.guoLabel",
          description: "et.guoDesc",
        },
      ],
    };
  },
  components: {
    SubHeader,
    Card,
  },
  mounted() {
    setTimeout(initAnimation, 0);
  },
};
</script>
<style scoped>
.box {
  margin: 100px auto 100px;
  width: 1200px;
  overflow: hidden;
  padding: 0 10px;
  box-sizing: border-box;
  /* display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: flex-start; */
}
.e {
  width: 1200px;
  margin: 90px auto 90px;
}
.list {
  margin: 0 auto 9px;
  text-align: center;
  vertical-align: top;
}
.list > img {
  margin: 0 35px;
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/Pages/ExpertTeam/ExpertTeam.vue